export default "__VITE_ASSET__Db6fzAjz__"